

































































































import Vue from 'vue'
import Component from 'vue-class-component'
import ModalComponent from '@/components/modal/ModalComponent.vue'
import {ChangeEmployeePasswordModel, ColorTheme, CompanyEmployeeModel, CompanyModel, EditEmployeeRequestModel, StatusType} from '@/services/types'
import {StoreActionTypes} from '@/store/types'
import { IconDefinition, faEllipsisV } from '@fortawesome/free-solid-svg-icons'
//import * as utils from '@/services/utils'
import EditCompanyEmployeeModalForm from '@/components/form/EditCompanyEmployeeModalForm.vue'
import ConfirmationComponent from '@/components/modal/ConfirmationComponent.vue'
import EditCompanyEmployeePasswordModalForm, { EditCompanyEmployeePasswordModalFormMethods } from '@/components/form/EditCompanyEmployeePasswordModalFrom.vue'

@Component({
    components: {
        EditCompanyEmployeeModalForm,
        EditCompanyEmployeePasswordModalForm,
        ModalComponent,
        ConfirmationComponent
    }
})
export default class GridComponent extends Vue {
    componentClass = "GridComponent"

    fields = [
        { key: 'lastname', sortable: true, label: 'ФИО', tdClass: 'name-td', thClass: 'name-th' },
        { key: 'status', sortable: true, label: 'Статус', tdClass: 'status-td', thClass: 'status-th' },
        { key: 'email', sortable: true, label: 'Email', tdClass: 'email-td', thClass: 'email-th' },
        { key: 'phone', sortable: true, label: 'Phone', tdClass: 'phone-td', thClass: 'phone-th' },
        // { key: 'role', sortable: true, label: 'Роль' },
        { key: 'action', label: '', sortable: false, tdClass: 'action-td', thClass: 'action-th' }               
    ]

    showEditEmployeeForm = false 
    ellipsis: IconDefinition = faEllipsisV
    selectedEmployeeId = null;

    deleteEmployeeConfirmationShow = false
    changeStatusEmployeeConfirmationShow = false
    transferOwnershipConfirmationShow = false
    editedEmployeeId: number | null = null

    get selectedCompanyId() {
        const c: CompanyModel = this.$store.getters.getCompaniesSelectedCompany;
        return c?.id;
    }

    get listItems(): CompanyEmployeeModel [] {
        return this.$store.getters.getEmployeesFilteredList
    }

    getStatus(status: StatusType) {
        return status == 'ACTIVE' ? 'Активен' : 'Деактивирован'
    }

    getChangeStatusItemTitle(status: StatusType) {
        return status == 'ACTIVE' ? 'Деактивировать' : 'Активировать'
    }

    // getRole(role: EmployeeRole){
    //     return utils.getUserRole(role)
    // }

    getName(item: CompanyEmployeeModel) {
        return `${item.lastname} ${item.firstname} ${item.surname}`
    }

    handleEditEmployeeBtnClick(id: number) {     
        this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_SELECTED_EMPLOYEE_CLEAR)   
        this.selectedEmployeeId = id
        this.showEditEmployeeForm = !this.showEditEmployeeForm
    }

	async handleEditEmployeeModalOkBtnClick() {
        const model: EditEmployeeRequestModel = (this.$refs.editEmployeeForm as EditCompanyEmployeeModalForm).getEditEmployeeRequestModel()
        await this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_EMPLOYEE_EDIT, model)
        this.handleEditEmployeeBtnClick(null)
    }

	get editedEmployeeDisabled (){
        return this.$store.getters.isEmployeesDataLoading
    }

    get getEmployeeName() {
        if (this.listItems.length > 0 && this.selectedEmployeeId) {
            return this.getName(this.listItems.find(item => item.id == this.selectedEmployeeId))
        }
        else {
            return ''
        }        
    }

    handleChangeStatusItemClick(id: number) {
        this.editedEmployeeId = id
        this.changeStatusEmployeeConfirmationShow = true
    }

    handleTransferOwnershipItemClick(id: number) {
        this.editedEmployeeId = id
        this.transferOwnershipConfirmationShow = true
    }

    handleDeleteItemClick(id: number) {
        this.editedEmployeeId = id
        this.deleteEmployeeConfirmationShow = true
    }

    get getEditedEmployeeName() {
        return this.listItems.length > 0 && this.listItems.find(item => item.id == this.editedEmployeeId) ? this.getName(this.listItems.find(item => item.id == this.editedEmployeeId)) : ''
    }

    async deleteEmployee() {
        await this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_EMPLOYEE_DELETE, {
            ids: [this.editedEmployeeId]
        })

        this.deleteEmployeeCancel()
    }

    deleteEmployeeCancel() {
        this.editedEmployeeId = null
        this.deleteEmployeeConfirmationShow = false
    }
    
    async transferOwnership() {
        await this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_TRANSFER_COMPANY_OWNERSHIP, {
            userId: this.editedEmployeeId
        })

        this.transferOwnershipCancel()
    }

    transferOwnershipCancel() {
        this.editedEmployeeId = null
        this.transferOwnershipConfirmationShow = false
    }

    changeEmployeeStatusCancel() {
        this.editedEmployeeId = null
        this.changeStatusEmployeeConfirmationShow = false
    }

    getEditedEmployeeStatus() {
        return this.listItems.length > 0 && this.listItems.find(item => item.id == this.editedEmployeeId) ? this.listItems.find(item => item.id == this.editedEmployeeId).status : null
    }

    get getEditedEmployeeOkTitle() {
        return this.getChangeStatusItemTitle(
            this.getEditedEmployeeStatus()
        )
    }

    async changeEmployeeStatus() {
        await this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_EMPLOYEE_CHANGE_STATUS, {
                id: this.editedEmployeeId, 
                status: this.getEditedEmployeeStatus()
            })
        this.changeEmployeeStatusCancel()
    }

    get setChangeStatusConfirmationOkBtnVariant() {
        return this.getOkBtnVariant(
            this.getEditedEmployeeStatus()
        )
    }
    
    getOkBtnVariant(status: StatusType): ColorTheme {
        return status == 'ACTIVE' ? 'danger' : 'success'
    }

    //#region Change password
    
    showChangePassEmployeeForm = false
    isChangeEmployeePassLoading = false

    handleChangePassItemClick(id: number) {
        this.editedEmployeeId = id
        this.showChangePassEmployeeForm = !this.showChangePassEmployeeForm
    }

    async handleChangePassModalOkBtnClick() {
        const formRef = this.$refs.editEmployeePasswordForm as unknown as EditCompanyEmployeePasswordModalFormMethods;
        const newPasswordModel = formRef.getNewPasswordValue();

        const request: ChangeEmployeePasswordModel = {
            userId: this.editedEmployeeId,
            companyId: this.selectedCompanyId,
            ...newPasswordModel
        }
        
        try {
            this.isChangeEmployeePassLoading = true
            await this.$store.dispatch(StoreActionTypes.SET_EMPLOYEES_EMPLOYEE_CHANGE_PASSWORD, request)
            formRef.resetFields();
            this.handleChangePassItemClick(null)
        } catch (e) {
            alert(`Произошла ошибка. ${e}`)
        } finally {
            this.isChangeEmployeePassLoading = false
        }
    }

    //#endregion
}
